module.exports = __webpack_public_path__ + "img/leftside_1000.7adbd65e.png";